
import { useState } from 'react';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Menu from './components/Menu';
import OwnerStory from './components/OwnerStory';
import News from './components/News';
import Access from './components/Access';
import Footer from './components/Footer';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex-shrink-0">
              <h1 className="text-2xl font-bold text-navy-900" style={{ fontFamily: '"Pacifico", serif' }}>
                WAVE RIDER
              </h1>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('concept')} className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                CONCEPT
              </button>
              <button onClick={() => scrollToSection('menu')} className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                MENU
              </button>
              <button onClick={() => scrollToSection('owner')} className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                OWNER
              </button>
              <button onClick={() => scrollToSection('news')} className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                NEWS
              </button>
              <button onClick={() => scrollToSection('access')} className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                ACCESS
              </button>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              <button onClick={() => scrollToSection('concept')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 cursor-pointer">
                CONCEPT
              </button>
              <button onClick={() => scrollToSection('menu')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 cursor-pointer">
                MENU
              </button>
              <button onClick={() => scrollToSection('owner')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 cursor-pointer">
                OWNER
              </button>
              <button onClick={() => scrollToSection('news')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 cursor-pointer">
                NEWS
              </button>
              <button onClick={() => scrollToSection('access')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 cursor-pointer">
                ACCESS
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-20">
        <Hero scrollToSection={scrollToSection} />
        <Concept />
        <Menu />
        <OwnerStory />
        <News />
        <Access />
      </main>

      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}
